<div class="overlay-content">
  <div
    class="text-center margin bottom-3x rts-image-container rts-overlay-bg"
    [ngClass]="{
      'rts-bg-one': active === 'eligibleProcedures',
      'rts-bg-two': active === 'quickAccess',
      'rts-bg-three': active === 'ssFacilities'
    }"
    *ngIf="!isMobile"
  >
    <div fxLayout="row" fxLayoutAlign="end">
      <mat-icon
        fxHide.lt-md
        svgIcon="dls-times-plain-light"
        class="font-bold rts-overlay-close-btn"
        (click)="closeDialog('X')"
        data-cy="rts-welcome-overlay.close-button"
      >
      </mat-icon>
    </div>
    <ng-container *ngIf="active !== 'ssFacilities'">
      <div
        fxLayout="row"
        class="text-center"
        [ngClass]="{
          'rts-title-slide-1': active === 'eligibleProcedures',
          'rts-title-slide-2': active === 'quickAccess'
        }"
      >
        <img src="/assets/images/rts-overlay-title-icon-white.svg" alt="" />
        <h4
          class="text-white pad left-1x"
          [innerHTML]="'rts_overlay_title_1' | translate"
        ></h4>
      </div>
    </ng-container>
    <div
      fxLayout="row"
      fxLayoutAlign="end end"
      *ngIf="active === 'ssFacilities'"
      class="rts-title-slide-3"
    >
      <img
        src="/assets/images/rts-overlay-title-icon-green.svg"
        alt=""
        class="rts-overlay-title-icon-green"
      />
      <h4
        class="rts-overlay-title-green pad left-1x"
        [innerHTML]="'rts_overlay_title_2' | translate"
      ></h4>
    </div>
  </div>

  <!-- mobile icon start -->
  <div class="rts-ssa-icon margin top-2x text-center" *ngIf="isMobile">
    <img
      class="h-100"
      src="/assets/images/rts-ssa-icon.svg"
      aria-hidden="true"
      alt=""
    />
  </div>
  <!-- mobile icon end -->

  <div
    ngClass.gt-sm="margin left-4x right-4x"
    ngClass.lt-lg="margin left-2x right-2x"
    class="text-center"
  >
    <ng-container *ngIf="!isMobile">
      <h3 class="bold" *ngIf="active === 'eligibleProcedures'">
        {{ 'rts_overlay_header_1' | translate }}
      </h3>
      <h3 class="bold" *ngIf="active === 'quickAccess'">
        {{ 'rts_overlay_header_2' | translate }}
      </h3>
      <h3 class="bold" *ngIf="active === 'ssFacilities'">
        {{ 'rts_overlay_header_3' | translate }}
      </h3>
    </ng-container>

    <!-- mobile headers start -->
    <div
      *ngIf="isMobile"
      class="w-100"
      fxLayout="row"
      fxLayoutAlign="center none"
    >
      <h4
        class="rts-mobile-title title-one-two"
        *ngIf="active === 'eligibleProcedures'"
      >
        {{ 'rts_overlay_header_1' | translate }}
      </h4>
      <h4
        class="rts-mobile-title title-one-two"
        *ngIf="active === 'quickAccess'"
      >
        {{ 'rts_overlay_header_2' | translate }}
      </h4>
      <h4
        class="rts-mobile-title title-three"
        *ngIf="active === 'ssFacilities'"
      >
        {{ 'rts_overlay_header_3' | translate }}
      </h4>
    </div>
    <!-- mobile headers end -->

    <p
      ngClass.gt-sm="rts-content desktop-one-two"
      ngClass.lt-lg="rts-content mobile-all-slides"
      *ngIf="active === 'eligibleProcedures'"
      [innerHTML]="'rts_overlay_body_content_one' | translate"
    ></p>
    <p
      ngClass.gt-sm="rts-content desktop-one-two"
      ngClass.lt-lg="rts-content mobile-all-slides"
      *ngIf="active === 'quickAccess'"
      [innerHTML]="'rts_overlay_body_content_two' | translate"
    ></p>
    <p
      ngClass.gt-sm="rts-content desktop-three"
      ngClass.lt-lg="rts-content mobile-all-slides"
      *ngIf="active === 'ssFacilities'"
      [innerHTML]="'rts_overlay_body_content_three' | translate"
    ></p>
    <div
      fxLayout="row"
      fxLayoutAlign="center center"
      class="margin top-1x bottom-5x"
      *ngIf="!isMobile"
    >
      <ng-container *ngIf="active !== 'ssFacilities'">
        <zelis-button
          forwardedClass="margin right-1x rts-btn-desktop"
          variant="stroked"
          color="accent"
          (clickFn)="closeDialog('Skip')"
          data-cy="rts-welcome-overlay-skip-button"
        >
          {{ 'rts_overlay_btn_skip' | translate }}
        </zelis-button>
        <zelis-button
          variant="flat"
          color="accent"
          forwardedClass="margin left-1x rts-btn-desktop"
          (clickFn)="nextSlide('Next')"
        >
          <span class="flex items-center justify-center">
            {{ 'rts_overlay_btn_next' | translate }}
            <mat-icon
              zelisButtonIcon
              svgIcon="dls-arrow-right-light"
              class="flex ml-1"
            ></mat-icon>
          </span>
        </zelis-button>
      </ng-container>
      <ng-container *ngIf="active === 'ssFacilities'">
        <zelis-button
          forwardedClass="margin right-1x rts-btn-desktop"
          variant="stroked"
          color="accent"
          (clickFn)="closeDialog('Done')"
        >
          {{ 'rts_overlay_btn_done' | translate }}
        </zelis-button>
        <zelis-button
          variant="flat"
          color="accent"
          forwardedClass="margin left-1x rts-btn-three"
          (clickFn)="navigateToMarketing('Show Me How')"
        >
          {{ 'rts_overlay_btn_show' | translate }}
        </zelis-button>
      </ng-container>
    </div>

    <!-- mobile buttons start -->
    <div
      fxLayout="row"
      fxLayoutAlign="center center"
      class="margin top-2x bottom-2x"
      *ngIf="isMobile"
    >
      <ng-container *ngIf="active !== 'ssFacilities'">
        <zelis-button
          color="accent"
          forwardedClass="rts-mobile-btn rts-mobile-btn-skip margin right-1x"
          variant="stroked"
          (clickFn)="closeDialog('Skip')"
        >
          {{ 'rts_overlay_btn_skip' | translate }}
        </zelis-button>
        <zelis-button
          variant="flat"
          color="accent"
          forwardedClass="rts-mobile-btn margin left-1x"
          (clickFn)="nextSlide('Next')"
        >
          {{ 'rts_overlay_btn_next' | translate }}
          <mat-icon
            zelisButtonIcon
            svgIcon="dls-arrow-right-light"
            class="flex ml-1 vert-middle rts-mobile-font"
          ></mat-icon>
        </zelis-button>
      </ng-container>
      <ng-container *ngIf="active === 'ssFacilities'">
        <zelis-button
          color="accent"
          forwardedClass="rts-mobile-btn margin right-1x"
          variant="stroked"
          (clickFn)="closeDialog('Done')"
        >
          {{ 'rts_overlay_btn_done' | translate }}
        </zelis-button>
        <zelis-button
          color="accent"
          variant="flat"
          forwardedClass="rts-mobile-btnt margin left-1x"
          (clickFn)="navigateToMarketing('Show Me How')"
        >
          {{ 'rts_overlay_btn_show' | translate }}
        </zelis-button>
      </ng-container>
    </div>
    <!-- mobile buttons end -->
  </div>
</div>
<div class="dots margin bottom-2x">
  <span
    [attr.data-name]="'eligibleProcedures'"
    [ngClass]="{ active: active === 'eligibleProcedures' }"
    (click)="updateActive($event)"
  >
  </span>
  <span
    [attr.data-name]="'quickAccess'"
    [ngClass]="{ active: active === 'quickAccess' }"
    (click)="updateActive($event)"
  >
  </span>
  <span
    [attr.data-name]="'ssFacilities'"
    [ngClass]="{ active: active === 'ssFacilities' }"
    (click)="updateActive($event)"
  >
  </span>
</div>
